export class UserPassword {
  oldPassword: string = "";
  newPassword: string = "";
  confirmPassword: string = "";
}
